import { Component, OnInit, ViewContainerRef, NgZone, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DetailsService } from './details.service';
import { Headers } from '@angular/http';
import { environment } from '../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';


@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.css']
})
export class DetailsComponent implements OnInit {

  // base url which is determinated by env
  apiUrl = environment.apiBaseUrl;
  // TODO bogdan: replace this with tenant code from sessionData
  defaultTenant;

  // offer id
  id: number;

  // extracting id from URL
  private sub: any;

  // all fields which are displayed on details page
  data: any;
  longText: string;
  subText1: string;
  subText2: string;
  shortText: string;
  header: string;
  subHeader: string;
  firstBoardType: string;

  // two arrays of dates for room type
  SGL: any[];
  DBL: any[];
  roomTypeNumber: any[] = [];

  // array of airports
  flightFrom: any[];

  // array of board types
  boards: any[];

  images: string[];

  // string for url of first image on slider
  imgSrc1: string = '';

  // category for star component
  category;

  fromPrice;

  translations = {};

  constructor(private router: Router,
      private route: ActivatedRoute,
      private detailsService: DetailsService,
      private ref: ChangeDetectorRef,
      private zone: NgZone,
      private toastr: ToastrService,
      private translate: TranslateService
  ) {

    this.translate.onDefaultLangChange.subscribe(
      done => this.translations = done.translations
    );

  }



  ngOnInit() {
    window.scrollTo(0, 0);

    let temp = localStorage.getItem('sessionData');
    let sessionData = JSON.parse(temp);

    this.defaultTenant = sessionData.tenantCode;
    sessionStorage.setItem('backLink', window.location.href);
        this.sub = this.route.params.subscribe(params => {
       this.id = +params['id']; // (+) converts string 'id' to a number
    });
    if (this.id) {
    this.detailsService.getOfferDetails(this.id).subscribe(
      data => {this.data = data,
        this.longText = data.longText;
        this.firstBoardType = data.accommodation.boardTypeName;
        this.header = data.header;
        this.subHeader = data.subHeader;
        this.subText1 = data.subText1;
        this.subText2 = data.subText2;
        this.shortText = data.shortText;
        this.category = data.accommodation.category;
        this.fromPrice = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(data.fromPrice/100);
        this.images = [];
        if (this.data.files) {
        this.imgSrc1 = this.apiUrl + 'dms/public/' + this.defaultTenant + '/' + this.data.files[0].id;
        for (let i = 1; i < data.files.length; i++) {
          this.images[i - 1] = this.apiUrl + 'dms/public/' + this.defaultTenant + '/' + this.data.files[i].id;
        }
        }else {
          this.imgSrc1 = 'https://www.novelupdates.com/img/noimagefound.jpg';
        }

        // setting up right price format for airports
        if (typeof this.data.flight.fromAirports !== 'undefined') {
            this.flightFrom = this.data.flight.fromAirports;
            for (let f of this.flightFrom){
              let price = f.price
              f.price = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(price/100);
            }
        }

        // setting up right price format for board types

        if (typeof this.data.accommodation.boardUpgrades !== 'undefined') {
          this.boards = this.data.accommodation.boardUpgrades;
          for (let b of this.boards){
            let price = b.price
            b.price = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(price/100);
          }
        }
         // push all object from first array
         let roomCounter2 = 0;
         if (this.data.accommodation.roomTypes[0].prices !== undefined) {
         for (let room of this.data.accommodation.roomTypes[0].prices){
               let tempDate = new Date(room.start);
               tempDate.setDate(tempDate.getDate() + this.data.durVal);
             this.roomTypeNumber.push({
                   roomType: this.data.accommodation.roomTypes[0].roomType,
                   price:  new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(room.price / 100),
                   id: room.id,
                   start: room.start,
                   end: tempDate
                 });
                 roomCounter2 ++;
             }
         }
         this.roomTypeNumber.splice(roomCounter2, this.roomTypeNumber.length);
         // copy DBL room array to temporary array
         let copyOfDoubleArray = new Array();
         for (let copy of this.data.accommodation.roomTypes[1].prices){
           copyOfDoubleArray.push({
             price: copy.price,
             start: copy.start,
             id: copy.id,
           });
         }
         // merge same dates from first and second array
         let roomCounter1 = 0;
         let doubleRoomIndex = 0;
         for (let room of this.roomTypeNumber){
               for (let i = 0; i < copyOfDoubleArray.length; i++) {
               console.log(copyOfDoubleArray);
               if (room.start === copyOfDoubleArray[i].start) {
                 // tslint:disable-next-line:max-line-length
                 room.price1 = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(copyOfDoubleArray[i].price / 100),
                 room.roomType1 = this.data.accommodation.roomTypes[1].roomType,
                 room.id1 = copyOfDoubleArray[i].id;
                 roomCounter1++;
                 copyOfDoubleArray.splice(i, 1);
                 i--;
             }
           }
         }
         this.roomTypeNumber.splice(roomCounter1 + roomCounter2 , this.roomTypeNumber.length);
         // push left object from second array
           for (let dbl of copyOfDoubleArray){
               let tempDate = new Date(dbl.start);
               tempDate.setDate(tempDate.getDate() + this.data.durVal);
               this.roomTypeNumber.push({
                 roomType1: this.data.accommodation.roomTypes[1].roomType,
                 price1: new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(dbl.price / 100),
                 id1: dbl.id,
                 start: dbl.start,
                 end: tempDate
               });
           }
      },

      // if some error occuers while calling api this will be displayed
      err => {
      this.toastr.error(this.translations['detailsPage']['common-error']);
      this.router.navigate(['']);
    },
        () => console.log('complete')
    )} else {
      // if there is no id in url this error will be displayed
      this.toastr.error(this.translations['detailsPage']['common-error']);
      this.router.navigate(['']);
    }
  }

  // buttons for navigation back and forward
      back() {
      this.router.navigate(['']);
    }

      booking(id) {
      this.router.navigate(['/details/booking', id]);
    }

      inquiry(id) {
      this.router.navigate(['/details/inquiry', id]);
    }

}



// WEBPACK FOOTER //
// ./src/app/details/details.component.ts